export const AUTH_CLEAR = 'AUTH_CLEAR';
export const AUTH_SET_JWT = 'AUTH_SET_JWT';
export const AUTH_SET_LOCAL = 'AUTH_SET_LOCAL';
export const LOGOUT = 'LOGOUT';

export default {
    setJwt: AUTH_SET_JWT,
    setLocal: AUTH_SET_LOCAL
};
